import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Portfolio from "./components/Portfolio";
import About from "./components/About";
import Services from "./components/Services";
import GraphicDesign from "./components/GraphicDesign";
import Blog from "./components/Blog";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function Site() {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(theme);
  }, [theme]);

  return (
    <div data-testid="app-root" className="App">
      <Nav theme={theme} setTheme={setTheme} />
      <main>
        <Hero />
        <Portfolio />
        <About />
        <Services />
        <GraphicDesign />
        <Blog />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: { background: "#12141D", color: "#F2EBE5", border: "1px solid rgba(209,138,88,0.4)" },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
